import React from "react";
import TransactionsReportView from "./TransactionsReportView";

/* "Regular Transaction" tab — enrolled students only, so the reference column
   is Emis ID and the Payment Mode column is dropped. */
const RegularTransaction = () => {
  return <TransactionsReportView type="regular" />;
};

export default RegularTransaction;
